export const SCHOOL_CLASSES = [
  "Class 6", "Class 7", "Class 8", "Class 9", "Class 10", "Class 11", "Class 12",
] as const;

export const COLLEGE_STREAMS = [
  "B.Tech", "B.E.", "B.Sc", "B.Com", "B.A.", "BCA", "BBA", "MBA", "MCA", "M.Tech", "M.Sc", "M.Com", "Other",
] as const;

export const COLLEGE_SEMESTERS = [
  "Sem 1", "Sem 2", "Sem 3", "Sem 4", "Sem 5", "Sem 6", "Sem 7", "Sem 8",
] as const;

export const SCHOOL_SUBJECTS = [
  "Mathematics", "Physics", "Chemistry", "Biology", "English", "Hindi",
  "Social Science", "History", "Geography", "Civics", "Economics",
  "Computer Science", "Accountancy", "Business Studies", "Political Science",
  "Sanskrit", "Environmental Studies", "Other",
];

export const COLLEGE_SUBJECTS = [
  "Engineering Mathematics", "Data Structures", "Algorithms",
  "Operating Systems", "DBMS", "Computer Networks", "OOP",
  "Software Engineering", "Web Development", "Machine Learning",
  "Artificial Intelligence", "Digital Electronics", "Microprocessors",
  "Thermodynamics", "Mechanics", "Organic Chemistry", "Inorganic Chemistry",
  "Financial Accounting", "Cost Accounting", "Business Law",
  "Economics", "Marketing", "Management", "Statistics", "Other",
];

export const ACCEPTED_MIME = {
  "application/pdf": "pdf",
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/msword": "doc",
} as const;

export const ACCEPTED_EXT_LIST = ".pdf,.jpg,.jpeg,.png,.docx,.doc";
export const MAX_FILE_BYTES = 15 * 1024 * 1024; // 15 MB
